// extracted by mini-css-extract-plugin
export default {"backdrop":"Model_backdrop__WSI4M","modal":"Model_modal__kEIgQ","slide-down":"Model_slide-down__umUPd"};